import React from 'react';
import GenericDialog from '../../../Components/Modals/GenericDialog';
import { classes } from '../../../Components/Modals/styles';
import { theme } from '../../../../ThemeContext/ThemeObject';

interface NoTimeslotsDialogProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
  noTimeslots: boolean;
  notEnoughSpots: boolean;
}

export default function NoTimeslotsDialog({
  open,
  onClose,
  noTimeslots,
  notEnoughSpots,
  onContinue
}: NoTimeslotsDialogProps) {
  const getDialogTitle = () => {
    if (noTimeslots) return 'No timeslots available';
    if (notEnoughSpots) return 'Not enough booking spots for candidates';
    return '';
  };

  const getDialogDescription = () => {
    if (noTimeslots) {
      return 'It looks like there are no timeslots available for your event type. Do you still want to continue?';
    }
    if (notEnoughSpots) {
      return 'Candidate count exceeds the available booking capacity. Do you still want to continue?';
    }
    return '';
  };

  return (
    <GenericDialog
      isDialogOpen={open}
      setDialogOpen={onClose}
      title={getDialogTitle()}
      description={getDialogDescription()}
      buttonCallback={onContinue}
      callbackLoading={false}
      buttonText="Yes, continue"
      secondaryButtonText="Back to editing"
      overrideColor={{
        primary: { ...classes.secondaryButtonAlternateColor, color: theme.palette.action.main },
        secondary: classes.primaryButtonAlternateColor
      }}
      switchOrder
      url=""
    />
  );
}
